module.exports = __webpack_public_path__ + "static/media/profile_pic_website.35fdbb25.png";